export const apiVersion = 'v1';
export const baseUrl = process.env.REACT_APP_API_BASE_URL;
